export default function(callback, currentItems, removedItems, options) {
  const self = this;
  self.defaults = {
    fileType: null,
    maxItems: null
  };
  self.config = _.extend({}, self.defaults, options);
  self.libraryItems = ko.observableArray([]);
  self.chosenItems = ko.observableArray([]);
  self.paginator = ko.observable();
  self.loading = ko.observable(false);
  self.newLink = ko.observable();
  self.newEmbed = {
    title: ko.observable(),
    code: ko.observable()
  };
  self.searchQuery = ko.observable();
  self.searchEnabled = ko.observable(false);
  self.searchEnabled.subscribe(function (value) {
    if (!self.searchEnabled()) {
      self.searchQuery('');
      self.doSearch();
    }
  });
  self.searchApplied = ko.computed(function () {
    return self.searchEnabled() && !_.isEmpty(self.searchQuery());
  });
  self.courseFilters = ko.observableArray([]);
  self.typeFilters = ko.observableArray([]);
  self.selectedCourseFilter = ko.observable();
  self.selectedTypeFilter = ko.observable(self.config.fileType);
  self.insertCallback = callback;
  self.toggleSearch = function () {
    if( self.searchEnabled() ){
      self.searchEnabled(false);
    } else {
      self.searchEnabled(true);
      let $el = $('#searchItems');
      $el.focus();
    }
  };

  self.addHiddenDivToBody = function() {
    let div = document.createElement('div');
    div.style.display = 'none';
    document.body.appendChild(div);
    return div;
  };

  self.render = function (template_id, render_callback) {
    let temporaryDiv = self.addHiddenDivToBody();
    ko.renderTemplate(
      template_id,
      self,
      {
        afterRender: render_callback,
      },
      temporaryDiv,
      'replaceNode'
    );
  };

  self.show = function () {
    self.render('media_library_modal_template', function(renderedElement) {
      self.$mediaLibrary = $('#media-library');
      self.$mediaLibrary.modal('show');
      self.$mediaLibrary.on('hidden.bs.modal', function () {
        self.$mediaLibrary.remove();
      });
    });
  };

  self.showAddModal = function () {
    self.render('media_library_add_template', function(renderedElement) {
      self.$addNew = $('#media-library-add');
      self.$addNew.modal('show');
      self.$addNew.on('hidden.bs.modal', function () {
        self.$addNew.remove();
      });
      self.initDropzone();
    });
  };

  self.hide = function () {
    self.$mediaLibrary.modal('hide');
  };

  self.deleteItem = function (item, event) {
    if (item.attached())
      return;

    const request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.media_library_item_path(item.id()),
      type: 'DELETE'
    });

    request.done(function(data, status, xhr) {
      self.libraryItems.remove(item);
      new Kadenze.Notice.success({});
    });

    request.fail(function(xhr, status, error) {
      new Kadenze.Notice.error({ message: xhr.responseJSON.errors });
    });
  };

  self.chooseItem = function(item, event) {
    if (!item.chosen() && self.config.maxItems && self.chosenItems().length >= self.config.maxItems) {
      Kadenze.Notice.error({message: `Sorry, you can not select more than ${self.config.maxItems} ${'item'.pluralize(self.config.maxItems)}`});
      event.stopImmediatePropagation();
    } else {
      return true;
    }
  };

  self.unchooseItem = function(item) {
    item.chosen(false);
  };

  self.clearChosenItems = function() {
    ko.utils.arrayForEach(self.libraryItems(), function(item) {
      item.chosen(false);
    });
  };

  self.insertMedia = function() {
    if (typeof self.insertCallback === 'function') {
      self.insertCallback.call(this, self.chosenItems());
    }
    $('#media-library').modal('hide');
  };

  self.placeholderImage = function(item) {
    return Kadenze.FileTypeMapping.getPlaceholderImage(item.type());
  };

  self.bgPlaceholderImageUrl = function(item) {
    return `url(${self.placeholderImage(item)})`;
  };

  self.handleMissingThumb = function(item) {
    item.file.thumb(null);
  };

  self.initUI = function() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.loadData);
  };

  self.initDropzone = function() {
    let storedFile;
    const $dzel = $('#js-new-media-dz', self.$addNew);

    if ($dzel.length == 0 || $dzel[0].dropzone) {
      return;
    }

    let mediaDZ;
    const messageObj = {
      title: 'New Media'
    };

    const opts = {
      url: Kadenze.Routes.attachments_path(),
      previewsContainer: '#dz-previews',
      autoProcessQueue: true,
      paramName: 'attachment[file]',
      acceptedFiles: _.isEmpty(self.selectedTypeFilter()) ? null : `${self.selectedTypeFilter().toLowerCase()}/*`,
      maxFilesize: 500,
      maxFiles: 30,
      hideUpperTitle: true
    };

    mediaDZ = new Kadenze.MediaLibraryDropZone($dzel, messageObj, opts);

    mediaDZ.on('addedfile', function(file) {
      // add a file to our files list
      const obsFile = {
        id: ko.observable(),
        name: ko.observable(file.name),
        meta: {},
        size: ko.observable(file.size),
        url: ko.observable(),
        status: ko.observable(file.status),
        type: ko.observable(file.type),
        upload: ko.observable(ko.mapping.fromJS(file.upload)),
        uuid: ko.observable(file.uuid),
        selected: ko.observable(false),
        clicked: ko.observable(false),
        chosen: ko.observable(false),
        file: ko.observable(),
        data: {},
        date: ko.observable(),
        download_path: ko.observable(),
        coursework: ko.observable(),
        attached: ko.observable(false),
        item_class: ko.observable(),
        media_urls: {}
      };
      obsFile.chosen.subscribe(function(newVal) {
        self.chosenChange(newVal, obsFile);
      });
      self.libraryItems.unshift(obsFile);
    });

    mediaDZ.on('sending', function(file) {
      Kadenze.UIUtil.showLoadingIndicator(self.$addNew);
    });

    mediaDZ.on('uploadprogress', function(file, progress, bytesSent) {
      // update the file in the files list
      storedFile = self.findFileByUUID(file.uuid);
      if (storedFile) {
        storedFile.upload().progress(file.upload.progress);
        storedFile.status(file.status);
      }
    });

    mediaDZ.on('error', function(file, errorMsg) {
      // show a message
    });

    mediaDZ.on('maxfilesexceeded', function(file) {
      self.libraryItems.remove(function(item) {
        return item.uuid() == file.uuid;
      });
    });

    mediaDZ.on('success', function(file, response) {
      // update the file in our files list
      storedFile = self.findFileByUUID(file.uuid);
      if (storedFile) {
        storedFile.upload().progress(file.upload.progress);
        storedFile.status(file.status);
        storedFile.id(response.files[0].id);
        storedFile.download_path(response.files[0].download_path);
        storedFile.meta = ko.mapping.fromJS(response.files[0].meta);
        storedFile.item_class(response.files[0].item_class);
        storedFile.file = ko.mapping.fromJS(response.files[0].file);
        storedFile.file.thumb = ko.observable(storedFile.file.thumb);
        storedFile.type(response.files[0].type);
        storedFile.media_urls = {
          h264_360_url: response.files[0].url
        };
      }
    });

    mediaDZ.on('queuecomplete', function () {
      self.$addNew.modal('hide');
    });

    return mediaDZ;
  };

  self.addLink = function () {
    const client_errors = ko.validation.group([self.newLink], { deep: true });
    if (client_errors().length === 0) {
      const request = new Kadenze.AjaxRequest({
        url: Kadenze.Routes.attachments_path(),
        type: 'POST',
        data: {attachment: { url: self.newLink() } }
      });

      request.done(function(data, status, xhr) {
        const file = data.files[0];
        const obsFile = ko.mapping.fromJS(_.extend({}, file, {selected: false, clicked: false, chosen: false}));
        self.libraryItems.unshift(obsFile);
        obsFile.chosen.subscribe(function(newVal) {
          self.chosenChange(newVal, obsFile);
        });
        self.$addNew.modal('hide');
        self.newLink('');
        self.newLink.isModified(false);
      });

      request.fail(function(xhr, status, error) {
        // show a message
      });
    } else {
      client_errors.showAllMessages();
    }
  };

  self.prefillURL = function (item, event) {
    if (_.isEmpty(self.newLink())) {
      self.newLink('http://');
      self.newLink.isModified(false);
    } else if (self.newLink().indexOf('http://') === -1 && self.newLink().indexOf('https://') === -1) {
      const oldLink = self.newLink();
      self.newLink('http://' + oldLink);
    }
  };

  self.addEmbed = function () {
    const client_errors = ko.validation.group([self.newEmbed.title, self.newEmbed.code], { deep: true });
    if (client_errors().length === 0) {
      const request = new Kadenze.AjaxRequest({
        url: Kadenze.Routes.attachments_path(),
        type: 'POST',
        data: {attachment: { data: {title: self.newEmbed.title(), embed: self.newEmbed.code() } } }
      });

      request.done(function(data, status, xhr) {
        const file = data.files[0];
        const obsFile = ko.mapping.fromJS(_.extend({}, file, {selected: false, clicked: false, chosen: false}));
        self.libraryItems.unshift(obsFile);
        obsFile.chosen.subscribe(function(newVal) {
          self.chosenChange(newVal, obsFile);
        });
        self.$addNew.modal('hide');
      });

      request.fail(function(xhr, status, error) {
        // show a message
      });
    } else {
      client_errors.showAllMessages();
    }
  };

  self.findFileByUUID = function(uuid) {
    return ko.utils.arrayFirst(self.libraryItems(), function(item) {
      return item.uuid() === uuid;
    });
  };

  self.subscribeToChosenChanges = function() {
    ko.utils.arrayForEach(self.libraryItems(), function(item) {
      item.chosen.subscribe(function(newVal) {
        self.chosenChange(newVal, item);
      });
    });
  };

  self.chosenChange = function(newVal, item) {
    if (newVal === true && self.chosenItems.indexOf(item) === -1) {
      self.chosenItems.push(item);
    }
    else {
      self.chosenItems.remove(item);
    }
  };

  self.updateChosenItems = function() {
    ko.utils.arrayForEach(self.libraryItems(), function(l_item) {
      const found_item = ko.utils.arrayFirst(self.chosenItems(), function (c_item) {
        return c_item.id() === l_item.id() && c_item.item_class() === l_item.item_class();
      });
      if (found_item) {
        self.chosenItems.remove(found_item);
        l_item.chosen(true);
      }
    });
  };

  self.doSearch = function() {
    self.loadData();
  };

  self.loadFilters = function() {
    const url = Kadenze.Routes.filters_media_library_items_path();
    const request = new Kadenze.AjaxRequest({
      url: url,
      type: 'GET',
    });

    request.done(function(data, status, xhr) {
      console.log(data);
      self.courseFilters(ko.mapping.fromJS(data.course_filters)());
      self.typeFilters(ko.mapping.fromJS(data.file_type_filters)());

      self.selectedTypeFilter.subscribe(function(newVal) {
        self.loadData();
      });

      self.selectedCourseFilter.subscribe(function(newVal) {
        self.loadData();
      });
    });

    request.error(function(xhr, status, error) {
      new Kadenze.Notice.error({ message: 'Unfortunately there was a problem loading the filters. The good news is you should still be able to use the rest of the functionality' });
    });
  };

  self.loadData = function(url) {
    // Get paginated results and bind them
    self.loading(true);
    url = url || Kadenze.Routes.media_library_items_path();
    if (self.searchApplied()) {
      url = Kadenze.Util.insertURLParam(url, 'search', self.searchQuery());
    }
    if (self.selectedCourseFilter()) {
      url = Kadenze.Util.insertURLParam(url, 'course', self.selectedCourseFilter());
    }
    if (self.selectedTypeFilter()) {
      url = Kadenze.Util.insertURLParam(url, 'type', self.selectedTypeFilter());
    }

    let mp;
    if ($('#media-library .js-loader').length > 0) {
      mp = new Mprogress({
        template: 4,
        start: true,
        parent: '#media-library .js-loader'
      });
    }

    const request = new Kadenze.AjaxRequest({
      url: url,
      type: 'GET',
      timeout: 30000
    });

    request.done(function(data, status, xhr) {
      console.log(data);
      const mapping = {
        'create': function (options) {
          let res = ko.mapping.fromJS(_.extend({}, options.data,
            {
              status: 'success',
              uuid: Kadenze.Util.UUID(1000),
              selected: false,
              chosen: false,
              clicked: false
            })
          );

          if (res.file.thumb) {
            res.file.thumb = ko.observable(res.file.thumb);
          }

          return res;
        }
      };
      const mapped = ko.mapping.fromJS(data.items, mapping);
      self.libraryItems(mapped());
      self.paginator(data.paginator);
      self.subscribeToChosenChanges();
      self.updateChosenItems();
      self.initUI();
      if(removedItems.length > 0) {
        self.unchoseRemovedItems(removedItems);
      }
    });

    request.error(function(xhr, status, error) {
      new Kadenze.Notice.error({ message: 'Unexpected error occurred trying to load media library data' });
    });

    request.always(function(xhr, status) {
      mp && mp.end();
      self.loading(false);
    });
  };

  self.unchoseRemovedItems = function(removedItems) {
    const mappedRemovedItems = _.map(removedItems, function (item) {
      return _.extend({}, item, {selected: false});
    });
    ko.utils.arrayForEach(self.libraryItems(), function(l_item) {
      const found_item = _.find(mappedRemovedItems, function (r_item) {
        return r_item.id() === l_item.id() && r_item.item_class() === l_item.item_class();
      });
      if (found_item) {
        l_item.chosen(false);
      }
    });
  };

  const __construct = function(that) {
    console.log('loading library data');
    // self.chosenItems(currentItems);
    if (currentItems && currentItems.length > 0) {
      let url = Kadenze.Routes.media_library_items_path();
      // group curren items by type
      const grouped = _.groupBy(currentItems, function (item) {
        return item.item_class();
      });

        // _.each(grouped, function(group) {
      for (let group in grouped) {
        const ids = _.map(grouped[group], function (_item) {
          return _item.id();
        });
        url = Kadenze.Util.insertURLParam(url, 'items[' + group + ']', ids.toString());
      }

      self.chosenItems(_.map(currentItems, function(item) {
        return _.extend({}, item, {selected: false});
      }));
      self.loadData(url);
    } else {
      self.loadData();
    }
    self.loadFilters();
  }(this);
}

